import React, {useState, useMemo, useCallback} from "react";
import { Input } from "../../ui/Input";
import { MultiTextInput } from "../../ui/MultiTextInput";
import { SelectCountry } from "../../selectors/country/selectCountry";
import { SelectRegulatoryBody } from "../../selectors/regulatoryBody/selectRegulatoryBody";
import useDeligenceStatus from "../../../hooks/useDeligenceStatus";
import { diligenceObservable } from "../../../observers/deligenceObservable";
import { CountryRiskPopup } from "../../popups/countryRiskPopup";
// import { AlreadyEnhancedPopup } from "../../popups/alreadyEnhancedPopup";
import { useLocation } from "react-router-dom";
import { RadioGroup } from "../../ui/RadioGroup";
import { yesNoOption } from "../../options/options";
import { SelectExchanges } from "../../selectors/exchanges/selectExchanges";
export const PartnershipForm = React.memo(({renderBy, index, formData, onChange, isReadOnly, isReport}) => {

    const { getDeligenceStatusByCountry } = useDeligenceStatus();
    const ownerId = useMemo(()=>{ return renderBy + index.toString() + "Partnership"}, [index, renderBy]);
    const [showPopup, setShowPopup] = useState(false);

    const handleCountryChange = useCallback(async (event) => {
                diligenceObservable.remove(ownerId);
                const selectedCountry = event.target.value;
                const name = event.target.name;
                if (selectedCountry !== "None") {
                    const response = await getDeligenceStatusByCountry(selectedCountry);
                    if (response) {
                        const hasEnhanced = response.some((item) => item.Diligence.toLowerCase() === "enhanced");
                        if (hasEnhanced) {
                            setShowPopup(true);   
                        }
                    }
                }
                let privateEvent = { target: { name: name, value: selectedCountry } };
                onChange(privateEvent);
            }, [getDeligenceStatusByCountry, onChange, ownerId]);
            const location = useLocation();
            
                    const isManagementStructurePage = location.pathname.includes("management-structure");
                    const labelText = isManagementStructurePage
                        ? "Is this manager entity regulated by a recognised regulatory body?"
                        : "Is this UBO entity regulated by a recognised regulatory body?";

    return (
        <>
            <Input
                label={"Name of Partnership"}
                name={"uboPartnershipName"}
                placeholder={"Name of Partnership"}
                disabled={isReadOnly}
                value={formData.uboPartnershipName}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <SelectCountry
                label={"Country of Incorporation"}
                name={"uboCountry"}
                disabled={isReadOnly}
                value={formData.uboCountry}
                onChange={(e)=>{handleCountryChange(e)}}
                isReport={isReport}
                required
            />

            <Input
                label={"Type of Partnership"}
                name={"uboPartnershipType"}
                placeholder={"Type of Partnership"}
                disabled={isReadOnly}
                value={formData.uboPartnershipType}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <Input
                label={"Registration Number"}
                name={"uboRegistrationNumber"}
                placeholder={"Registration Number"}
                disabled={isReadOnly}
                value={formData.uboRegistrationNumber}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <Input
                label={"Business Address"}
                name={"uboBusinessAddress"}
                placeholder={"Business Address"}
                disabled={isReadOnly}
                value={formData.uboBusinessAddress}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <MultiTextInput
                label={"Partners"}
                name={"uboPartners"}
                disabled={isReadOnly}
                values={formData.uboPartners || []}
                onChange={onChange}
                isReport={isReport}
                required
            />
            <RadioGroup
              label={"Is Entity listed on the Register of Overseas Entities?"}
              disabled={isReadOnly}
              isReport={isReport}
              name={"uboOverseasEntities"}
              value={formData.uboOverseasEntities}
              onChange={onChange}
              options={yesNoOption}
            />
            {formData.uboOverseasEntities === "Yes" && (
             <Input 
                            label={"Registered Overseas Entities Number"}
                            name={"uboOverseasEntitiesNumber"}
                            isReport={isReport}
                            placeholder={"Registered Overseas Entities Number"}
                            disabled={isReadOnly}
                            value={formData.uboOverseasEntitiesNumber}
                            onChange={onChange}
                        />
            )
            }
            <RadioGroup
              label={labelText}
              disabled={isReadOnly}
              isReport={isReport}
              name={"uboRegulatory"}
              value={formData.uboRegulatory}
              onChange={onChange}
              options={yesNoOption}
              required
            />
 {formData.uboRegulatory === "Yes" && (
            <>
             <SelectRegulatoryBody 
               label="Select Regulatory Body"
               isReport={isReport}
               name={"uboRegulatoryBody"}
               value={formData.uboRegulatoryBody}
               onChange={onChange}
               disabled={isReadOnly}
               country={formData.uboCountry}
             />
             <Input 
                           label={"Enter Regulatory Reference Number"}
                           name={"uboRegulatoryReferenceNumber"}
                           isReport={isReport}
                           placeholder={"Enter Regulatory Reference Number"}
                           disabled={isReadOnly}
                           value={formData.uboRegulatoryReferenceNumber}
                           onChange={onChange}
                       />
                       </>
           )}
           <RadioGroup
             label={"Is Entity listed on a recognised exchange?"}
             disabled={isReadOnly}
             isReport={isReport}
             name={"uboRecognisedExchange"}
             value={formData.uboRecognisedExchange}
             onChange={onChange}
             options={yesNoOption}
           />
           {formData.uboRecognisedExchange === "Yes" && (
               <SelectExchanges
                               label={"Select the recognised exchange"}
                               name={"uboRecognisedExchangeBodies"}
                               value={formData.uboRecognisedExchangeBodies}
                               onChange={onChange}
                               disabled={isReadOnly}
                               country={formData.uboCountry}
                               isReport={isReport}
                           />
           )
           
           }
            {showPopup && diligenceObservable.isEnhanced() === false && <CountryRiskPopup ownerId={ownerId} openPopup={true}/>}
            {/* {showPopup && diligenceObservable.isEnhanced() === true && <AlreadyEnhancedPopup openPopup={true}/>} */}
        </>
    )
});